import Toastr from "../../../components/Toastr"
const parent = 'SETTING_'

const DEFAULT_STATE = {
  eyeglass_stock_lenses: [],
  eyeglass_stock_lens: {},
  meta: { pagination: {} },
  saving: false
}
let changes = null;
export default function eyeglassStockLensesReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  let eyeglassStockLenses = [];
  let eyeglassStockLensData = [];
  let updatedRecord = {};
  switch (action.type) {
    case `${parent}EYEGLASS_STOCK_LENSES_LOAD_PENDING`:
      return { ...state, saving: true };

    case `${parent}EYEGLASS_STOCK_LENSES_LOAD_REJECTED`:
    case `${parent}EYEGLASS_STOCK_LENS_CREATE_REJECTED`:
    case `${parent}EYEGLASS_STOCK_LENS_UPDATE_REJECTED`:
    case `${parent}EYEGLASS_STOCK_LENS_DELETE_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.status_code)
      changes = {
        saving: false
      }
      return { ...state, ...changes };

    case `${parent}EYEGLASS_STOCK_LENSES_LOAD_FULFILLED`:
      changes = {
        eyeglass_stock_lenses: response.eyeglass_stock_lens,
        meta: response.meta,
        saving: false
      };
      return { ...state, ...changes };

    case `${parent}EYEGLASS_STOCK_LENS_LOAD_FULFILLED`:
      changes = {
        eyeglass_stock_lens: response.eyeglass_stock_lens,
        saving: false
      }
      return { ...state, ...changes };

    case `${parent}EYEGLASS_STOCK_LENS_CREATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      eyeglassStockLenses = [...state.eyeglass_stock_lenses]
      let newRecord = response.eyeglass_stock_lens
      changes = {
        eyeglass_stock_lenses: [...eyeglassStockLenses, newRecord],
        editing: false,
        saving: false
      }
      return { ...state, ...changes };

    case `${parent}EYEGLASS_STOCK_LENS_UPDATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      eyeglassStockLenses = [...state.eyeglass_stock_lenses];
      updatedRecord = response.eyeglass_stock_lens;
      for (const [index, eyeglassLens] of eyeglassStockLenses.entries()) {
        if (eyeglassLens.id === updatedRecord.id) {
          eyeglassStockLensData = [
            ...eyeglassStockLenses.slice(0, index),
            updatedRecord,
            ...eyeglassStockLenses.slice(index + 1)
          ];
        }
      }
      changes = {
        eyeglass_stock_lenses: eyeglassStockLensData,
        editing: false,
        saving: false
      };
      return { ...state, ...changes };

    case `${parent}EYEGLASS_STOCK_LENS_DELETE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      eyeglassStockLenses = [...state.eyeglass_stock_lenses];
      for (const [index, eyeglassLense] of eyeglassStockLenses.entries()) {
        if (eyeglassLense.id === response.eyeglass_stock_lens.id) {
          eyeglassStockLenses.splice(index, 1);
        }
      }
      return {
        ...state,
        eyeglass_stock_lenses: eyeglassStockLenses,
        error: null
      };

    case `${parent}EYEGLASS_STOCK_LENS_DUPLICATE`:
      changes = {
        editing: {
          id: 'New',
        },
        eyeglass_stock_lens: { ...action.eyeglassStockLens, id: null },
      };
      return { ...state, ...changes };

    case `${parent}EYEGLASS_STOCK_LENS_EDIT`:
      changes = {
        editing: {
          id: action.id,
        },
        eyeglass_stock_lens: {}
      };
      return { ...state, ...changes };

    case `${parent}EYEGLASS_STOCK_LENS_EDIT_CANCEL`:
      changes = {
        editing: false
      };
      return { ...state, ...changes };

    default:
      return state;
  }
}